<script>
    export default {
        mounted() {
            let replaceElement = (element) => {
                let svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                let use = document.createElementNS("http://www.w3.org/2000/svg","use");
                use.setAttributeNS('http://www.w3.org/1999/xlink','xlink:href',  element.dataset.src);
                // Pass switch icon if available
                if ( element.dataset.hasOwnProperty('switchIcon')) {
                    use.setAttribute('data-switch-icon', element.dataset.switchIcon);
                }
                svg.appendChild(use);
                // Put original classes
                svg.classList = element.classList;
                // Replace with the new svg
                element.replaceWith(svg);
            };

            let elements = Array.prototype.slice.call( document.querySelectorAll("svg[data-src]"));

            if ("IntersectionObserver" in window ) {
                let observer = new IntersectionObserver(function(entries) {
                    entries.forEach(function(entry) {
                        if (entry.intersectionRatio > 0) {
                            replaceElement(entry.target);
                            observer.unobserve(entry.target);
                        }
                    });
                });
                elements.forEach((element) => {
                    observer.observe(element);
                });
            } else {
                elements.forEach((element) => {
                    replaceElement(element);
                });
            }
        },

        render() {
            return [];
        },
    }
</script>
